export class Logo {
  extension: string;
  id: number;
  imageContentId: string;
  originalName: string;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/Logo.ts